import TagAlertValue from './TagAlertValue'

export default class TagLinkAlertValue extends TagAlertValue {
  linkText: string

  constructor(data: any) {
    super(data)
    this.linkText = data.linkText
  }
}
